import { useMemo, useState } from 'react';

const MIN_SEARCH_LENGTH = 4;

// Filtra o catálogo de produtos por código ou nome, só a partir de
// MIN_SEARCH_LENGTH caracteres digitados — mesma regra das telas antigas de
// integração.
export function useProductSearch(products) {
  const [term, setTerm] = useState('');

  const results = useMemo(() => {
    const trimmed = (term || '').trim();
    if (trimmed.length < MIN_SEARCH_LENGTH) return [];

    const upperTerm = trimmed.toUpperCase();
    return (products || []).filter((product) => {
      const code = (product.code || '').toUpperCase();
      const name = (product.name || '').toUpperCase();
      return code.includes(upperTerm) || name.includes(upperTerm);
    });
  }, [products, term]);

  return { term, setTerm, results, minLength: MIN_SEARCH_LENGTH };
}
